core.factory('casAuthInterceptor', [ '$q',
    function ($q) {
        return {
            response: function (response) {
                if (response && response.headers && response.headers('user') === null && response.headers('Content-Type') !== null) {
                    window.location.reload();
                    return $q.reject(response);
                }

                return response;
            }
        };
    }
]);
